import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Divider, Flex, Modal, Typography, message as messagePopup } from 'antd';
import RegulationsDetailTable from './regulationsDetailTable';
import TextArea from 'antd/es/input/TextArea';
import { Link } from 'react-router-dom';
import mdmService from '../../services/MDMService';
import { useSelector } from 'react-redux';
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
const RegLibReqForPropDialog = ({ title, open, handleCloseModal, data }) => {
    const [characterCount, setCharacterCount] = useState(0);
    const [message, setMessage] = useState("");
    const [messageApi, contextHolder] = messagePopup.useMessage();
    const applicationData = useSelector((state) => state.applicationData);
    const handleOk = () => {
        var _a, _b, _c, _d, _e, _f;
        const product = data === null || data === void 0 ? void 0 : data.lstMapProductType;
        let prodStrList = "";
        if (product && product.length) {
            product.forEach((sub, index) => {
                prodStrList = prodStrList.concat(prodStrList + ", " || "", (sub === null || sub === void 0 ? void 0 : sub.strProductTypes) || "");
            });
        }
        let currentTime = Date.now();
        let time = currentTime / 100000;
        let intProposalId = Math.floor(time);
        const regulatoryProposal = {
            strRegLibId: data === null || data === void 0 ? void 0 : data.strRegLibId,
            objCountry: data === null || data === void 0 ? void 0 : data.objLuCountry,
            strLstProducts: (data === null || data === void 0 ? void 0 : data.boolIsAllProductTypesSelected) ? "All" : prodStrList,
            strLstServices: data === null || data === void 0 ? void 0 : data.strServiceTypes,
            strRegLibDetailUrl: window.location.origin + `/regulatory-library-details/${(data === null || data === void 0 ? void 0 : data.strRegLibId) ? btoa(data === null || data === void 0 ? void 0 : data.strRegLibId) : null}`,
            intProposalId: intProposalId,
            objCreatedBy: { objUser: {
                    strLongDesc: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId,
                    intId: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID
                } },
            strMessage: message
        };
        mdmService.saveRegProposal(regulatoryProposal);
        commonService
            .logUserActivity((_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserEmailId, UserActivity.CP__RegLibDashboard_Send_Proposal);
        setMessage("");
        messageApi.open({
            key: 'saved_reg_prop',
            type: 'success',
            content: 'Regulation proposal saved successfully',
            duration: 3,
        });
        handleCloseModal();
    };
    const handleCancel = () => {
        handleCloseModal();
    };
    const formatCharacterCount = (characterCount, maxLength) => {
        return `${maxLength}/${maxLength - characterCount}`;
    };
    return (_jsxs(_Fragment, { children: [contextHolder, _jsxs(Modal, { title: title, open: open, onOk: handleOk, onCancel: handleCancel, footer: [
                    _jsx(Button, { onClick: handleCancel, children: "Cancel" }, "back"),
                    _jsx(Button, { type: "primary", onClick: handleOk, children: "Submit" }, "submit")
                ], children: [_jsx(Divider, { style: { margin: '10px 0px' } }), _jsxs(Flex, { vertical: true, gap: 5, children: [_jsx(Link, { to: `/regulatory-library-details/${(data === null || data === void 0 ? void 0 : data.strRegLibId) ? btoa(data === null || data === void 0 ? void 0 : data.strRegLibId) : null}`, children: data === null || data === void 0 ? void 0 : data.strTitle }), _jsx("div", { style: {
                                    maxHeight: '200px',
                                    overflowX: 'scroll',
                                    scrollbarWidth: 'thin',
                                    scrollbarColor: 'rgba(0, 0, 0, 0.2) rgba(255, 255, 255, 0.1)'
                                }, children: _jsx(RegulationsDetailTable, { data: data }) }), _jsx(Typography.Text, { children: "Message:" }), _jsx(TextArea, { rows: 4, maxLength: 2000, value: message, onChange: (e) => {
                                    setCharacterCount(e.target.value.length);
                                    setMessage(e.target.value);
                                } }), _jsxs(Typography.Text, { type: "danger", children: ["Maximum allowed Characters : ", formatCharacterCount(characterCount, 2000), " (remaining)"] })] })] })] }));
};
export default RegLibReqForPropDialog;
